import React from 'react'; // eslint-disable-line
import styles, { StyledComponent } from '../../../../styles/styles';
import { Grid, withStyles } from '@material-ui/core';
import { LabeledValue } from '../../../../controls/labeled-value';
import { getCodeDescription, getDisplayDate } from '../../../../shared-functions';
import { BeneficiaryDetails } from '../../../reducer';

type Props = StyledComponent & {
    personalDetails?: BeneficiaryDetails;
};
const raPaymentWTIDetailsView: React.FunctionComponent<Props> = ({ personalDetails }: Props) => {
    if (personalDetails === null) {
        return null;
    }
    return (
        <React.Fragment>
            <Grid item xs={12} container justify="flex-start">
                <Grid item xs={4} lg={3}>
                    <LabeledValue
                        label="WTI country tax of residency"
                        value={getCodeDescription('wticountry', personalDetails?.wtiCountry)}
                    />
                </Grid>
                <Grid item xs={4} lg={2}>
                    <LabeledValue label="Mail preference" value={personalDetails?.emailAddress} />
                </Grid>
                <Grid item xs={4} lg={2}>
                    <LabeledValue label="WTI Exception" value={personalDetails?.wtiException} />
                </Grid>
                <Grid item xs={4} lg={2}>
                    <LabeledValue
                        label="WTI Reason Code"
                        value={getCodeDescription(
                            'wtiexception',
                            personalDetails?.wtiExceptionCode
                        )}
                    />
                </Grid>
                <Grid item xs={4} lg={1}>
                    <LabeledValue
                        label="Effective Date"
                        value={getDisplayDate(personalDetails?.effectiveDate)}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export const RaPaymentWTIDetailsView = withStyles(styles)(raPaymentWTIDetailsView);
